import React from 'react';
import ArrowClockwise from '@uber/base-icons/arrow-clockwise';
import { styled, useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { LabelSmall } from 'baseui/typography';
import { ObjectDetails } from '../classification/object-details';
import { ObjectClassificationContainer, StickyActionContainer } from '../styled-component-overrides';
import type { ReviewAnnotationT } from '../types';
const ActionContainer = styled(StickyActionContainer, ({
  $theme
}) => ({
  marginBottom: `-${$theme.sizing.scale500}`
}));
type Props = {
  annotation: ReviewAnnotationT;
  handleRevertToPending: () => void;
};
export const ObjectDetailsPanel = ({
  annotation,
  handleRevertToPending
}: Props) => {
  const [_, theme] = useStyletron();
  return <>
      <ObjectClassificationContainer>
        <ObjectDetails annotation={annotation} />
      </ObjectClassificationContainer>
      <ActionContainer>
        <Button size={SIZE.small} kind={KIND.primary} startEnhancer={<ArrowClockwise />} onClick={handleRevertToPending} overrides={{
        Root: {
          style: {
            flex: 1
          }
        }
      }}>
          <LabelSmall color={theme.colors.contentInversePrimary}>Revert to Pending</LabelSmall>
        </Button>
      </ActionContainer>
    </>;
};